<ng-container *transloco="let t;">
    <hr/>
    <form [formGroup]="todoForm" (ngSubmit)="submitTodo()">
        <div class="mt-2">
            <p class="card-text d-block mb-1">{{ t('Configure notification header (Upload pdf step - Bulk upload modal) - Customize notification options') }}</p>
        </div>
        <div class="row">
            <div class="col-xs-12 col-sm-6">
                <div class="row">
                    <div class="col-12 col-lg-6 pe-0">
                        <div class="form-group mb-0  p-0">
                            <label for="import-user">{{ t('User dropdown label (Upload pdf step - Bulk upload modal) - User') }}:</label>
                            <ng-select #SelectDocTypeSR formControlName='user_id' id="import-user"
                                [items]="userData$ | async" [searchable]="false" bindValue="id" bindLabel="name"
                                [placeholder]="t('Select empty placeholder (drop down list) - Please select')">
                                <ng-template ng-header-tmp>
                                    <input class="form-control w-100" type="text"
                                        (input)="filterUser($event.target.value)" />
                                </ng-template>
                            </ng-select>
                            <div class="invalid-feedback d-block">
                                <div *ngIf="submitted && todoForm?.controls['userId']?.hasError('required')">
                                    {{ t('Field required (form validation) - Field name is required',
                                    { fieldName : t('User dropdown label (Upload pdf step - Bulk upload modal) - User')}) }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <div class="form-group">
                            <label for="import-due-date">{{ t('Due date picker label (Upload pdf step - Bulk upload modal) - Due date') }}</label>
                            <div class="col-12 col-lg-6 p-0">
                                <div class="input-group CC_datePicker">
                                    <input type="text" id="import-due-date" mwlFlatpickr
                                        [value]="todoForm?.controls?.due_date?.value" class="form-control"
                                        (change)="dueDate($event)" [altInput]="true" [altFormat]="(false | userTimeZoneFormat) | async" [convertModelValue]="true"
                                        [ngClass]="{'is-invalid error' : submitted && todoForm?.controls?.due_date?.errors }" />

                                    <div class="invalid-feedback d-block">
                                        <div *ngIf="submitted && todoForm?.controls['due_date']?.hasError('required')">
                                            {{ t('Field required (form validation) - Field name is required', {
                                            fieldName : t('Due date picker label (Upload pdf step - Bulk upload modal) - Due date') }) }}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-xs-12 col-sm-6">
                <label for="import-description">{{ t('Description label (Upload pdf step - Bulk upload modal) - Description') }}</label>
                <fieldset class="form-label-group">
                    <textarea class="form-control" id="import-description" rows="3" formControlName="description"
                        [placeholder]="t('Description placeholder (Upload pdf step - Bulk upload modal) - Description')"></textarea>
                </fieldset>

                <div class="invalid-feedback d-block">
                    <div *ngIf="submitted && todoForm.controls['description'].hasError('required')">{{ t('Field required (form validation) - Field name is required',
                        { fieldName : t('Description label (Upload pdf step - Bulk upload modal) - Description')}) }}</div>
                </div>
            </div>
        </div>
    </form>
</ng-container>
